import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { RootState } from "../store/index";
import sbgSlice from "../slices/SBGSlice";
import SBGService from "../../services/SBGService";
import { SBGModel } from "../../models/SBGModel";

export const sbgActions = sbgSlice.actions;

export const fetchSBGs = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(sbgActions.setIsSbgsFetching(true));
    const response: SBGModel[] = await SBGService.getAllSBGs();
    dispatch(sbgActions.setSBGs(response));
    dispatch(sbgActions.setIsSbgsFetching(false));
  };
};

export const fetchParticularUser = (
  user_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: SBGModel = await SBGService.getParticularSBG(user_id);
    dispatch(sbgActions.setParticularSBG(response));
  };
};
